module.exports = __webpack_public_path__ + "media/V117.f4a8c83c.mp4";